module.exports = __webpack_public_path__ + "static/media/color-diamond.c143dc49.svg";